import script from "./ProformaInvoiceSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./ProformaInvoiceSuccess.vue?vue&type=script&setup=true&lang=js"

import "./ProformaInvoiceSuccess.vue?vue&type=style&index=0&id=4cacbe72&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cacbe72"]])

export default __exports__